import { Box, styled } from '@mui/material';

export const RequestDatesList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  margin: 0,
  padding: 0,
  '& > div': {
    marginBottom: '15px',
    '&:last-child': {
      marginBottom: 0
    }
  }
});
